export class GamesService {
    constructor(httpService, gamesFactory) {
        this.httpService = httpService;
        this.gamesFactory = gamesFactory;
    }
    async createNewGame(id, roomId, waitTime, type, useCheckers, playWithPaper) {
        const response = await this.httpService.post('game', { id, roomId, waitTime, type, useCheckers, playWithPaper });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al crear el juego.');
        }
    }
    async getEndedGamesCount(managerId) {
        const response = await this.httpService.get(`manager/${managerId}/num-games`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el número de juegos del manager.');
        }
        const { gamesCount } = await response.json();
        return gamesCount;
    }
    async getGameInCourseForTheCurrentManager() {
        // Code error e-1001
        const response = await this.httpService.get('game/managed-by');
        if (response.ok) {
            return this.createGame(await response.json());
        }
        if (response.status === 404) {
            return null;
        }
        throw new Error('Ha ocurrido un error al obtener el juego del manager actual.');
    }
    async getGame(gameId) {
        const response = await this.httpService.get(`game/${gameId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el juego.');
        }
        return this.createGame(await response.json());
    }
    async cancelGame(gameId, cancelMotive) {
        const response = await this.httpService.post(`game/cancel/${gameId}`, { cancelMotive });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al cancelar el juego.');
        }
    }
    async startGame(gameId) {
        const response = await this.httpService.get(`game/${gameId}/start`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al iniciar el juego.');
        }
    }
    createGame(data) {
        return this.gamesFactory.createGame(data.id, data.code, data.roomId, data.managerId, new Date(data.creationDate), data.type, data.state, data.waitTime, data.numbers, data.useChecker, data.playWithPaper);
    }
}
